// API Configuration
// - DEV mode: Uses local JS parser (no server needed)
// - PROD mode: Calls Ktor server API

import { getOrCreateClientId } from './api/clientId'

export type AnalysisMode = 'dev' | 'prod'

// Read from environment variable, default to 'dev'
export const API_MODE: AnalysisMode =
    (import.meta.env.VITE_API_MODE as AnalysisMode) || 'dev'

export const API_BASE_URL =
    import.meta.env.VITE_API_URL || 'http://localhost:8080'

export const config = {
    mode: API_MODE,
    apiUrl: API_BASE_URL,
    // Persistent UUID stored in localStorage. Survives reloads, deploys,
    // and IP changes — see api/clientId.ts for the privacy details.
    sessionId: getOrCreateClientId(),
}

console.log(`[EN] Running in ${config.mode.toUpperCase()} mode`)
